/* 
-----------------------------------------------------------------------------
| DATE PAGE
-----------------------------------------------------------------------------
- description: no booking data logic goes here, just metrics.
*/
import { FC, useEffect } from "react";
import { DateSelection } from "../components/DateSelection";
import { metrics, ROUTES, voiceAssistant } from "../utils/symbols";
import { useApp } from "../context/useApp";
import { _ } from "../utils/helpers";

export const DateSelectionPage: FC = () => {

    const {
        state: { booking } 
    } = useApp()

    return (
        <main 
            id="date-selection-page" 
            className="page-container" 
            role="application"
            aria-label={_('0ar_tosta__')}
        >
            <DateSelection />
        </main>
    )
}